import { PlaybackState } from "@tv4/avod-web-player-common";
import { useCallback } from "react";

import PauseSvg from "../icons/pause.svg";
import PlaySvg from "../icons/play.svg";
import { useControls, usePlayerState } from "../providers/CoreProvider";
import { useTranslations } from "../providers/TranslationsProvider";
import { PlayerControlButtonComponent } from "./PlayerControlButton";

export const PlayPauseButton = () => {
  const { playbackState } = usePlayerState();
  const controls = useControls();
  const translations = useTranslations();

  const togglePlayPause = useCallback(() => {
    if ([PlaybackState.PAUSED, PlaybackState.ENDED].includes(playbackState)) {
      controls?.play?.();
    } else {
      controls?.pause?.({ programmatic: false });
    }
  }, [playbackState, controls]);

  const isPaused = playbackState === PlaybackState.PAUSED;

  return (
    <PlayerControlButtonComponent
      // TODO: the voice over pronunces this very swenglish "spase"
      aria-keyshortcuts="Space"
      aria-label={translations(
        isPaused
          ? "player__a11y__hover_label_play_button"
          : "player__a11y__hover_label_pause_button"
      )}
      onClick={togglePlayPause}
      interactive
      Icon={playbackState === PlaybackState.PAUSED ? <PlaySvg /> : <PauseSvg />}
      hoverText={translations(
        isPaused
          ? "player__a11y__hover_label_play_button"
          : "player__a11y__hover_label_pause_button"
      )}
    />
  );
};

export default PlayPauseButton;
